import React, { useEffect, useRef, useState } from "react";
import "./NetworkPopup.css";
import { NETWORK_UI_CONFIG } from "./constants";

const NetworkPopup = ({ status }) => {
  const [visible, setVisible] = useState(false);
  const [uiState, setUiState] = useState(null);
  const [closing, setClosing] = useState(false);
  const prevStatus = useRef(status);

  useEffect(() => {
    const prev = prevStatus.current;

    if (status === "weak" || status === "poor" || status === "disconnected") {
      setUiState(status);
      setClosing(false);
      setVisible(true);
    }

    if (status === "good" && ["weak", "poor", "disconnected"].includes(prev)) {
      setUiState("online");
      setClosing(false);
      setVisible(true);
    }

    prevStatus.current = status;
  }, [status]);

  const closePopup = () => {
    setClosing(true);
    setTimeout(() => setVisible(false), 250);
  };

  if (!visible || !uiState) return null;

  const { title, message, border, bg, text, icon } = NETWORK_UI_CONFIG[uiState];

  return (
    <div className="network-popup-wrapper">
      <div
        className={`network-popup-card ${closing ? "closing" : ""}`}
        style={{ background: bg, borderLeftColor: border, color: text }}
      >
        <div className="network-popup-icon">{icon}</div>

        <div style={{ flex: 1 }}>
          <div className="network-popup-title">{title}</div>
          <div className="network-popup-message">{message}</div>
        </div>

        <button className="network-popup-close" onClick={closePopup}>
          ✖
        </button>
      </div>
    </div>
  );
};

export default NetworkPopup;
